import React, { Component } from 'react';
import classNames from 'classnames';

class SettingsNav extends Component {

    handleClickSettings( setting, value ) {

        let { settingsActions } = this.props;
        settingsActions.setSettingsValue( setting, value );

    }

    renderSettingItem( item, settings ) {

        let itemClass = classNames({
            'dropdown-item': true,
            'active': ! settings[item.setting]
        });

        return (
            <a className={itemClass} href="#" key={item.setting} onClick={ this.handleClickSettings.bind( this, item.setting, ! settings[item.setting] ) }>{item.name}</a>
        )

    }

    render() {

        let { settings } = this.props;

        return (
            <div className="pull-xs-right">
                <div className="btn-group">
                    <button type="button" className="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Preview Settings
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">

                        {
                            settings.items.map( ( item ) => {
                                return this.renderSettingItem( item, settings );
                            })
                        }

                    </div>
                </div>
            </div>
        )
    }

}

export default SettingsNav;


/** WEBPACK FOOTER **
 ** ./src/components/NavBar/SettingsNav/index.js
 **/